import { render } from "./BaseMenu.vue?vue&type=template&id=00ba969b&scoped=true"
import script from "./BaseMenu.vue?vue&type=script&lang=js"
export * from "./BaseMenu.vue?vue&type=script&lang=js"

import "./BaseMenu.vue?vue&type=style&index=0&id=00ba969b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00ba969b"

export default script